import { Action } from 'react-fetching-library';

export const getPageList: Action = {
  method: 'GET',
  endpoint: 'items/pages',
};
